import { ErrorCode } from '@/shared/enums';

export default class Captcha {
  constructor(key) {
    this.key = key;
    this.error = {
      data: {
        errors: [{ code: ErrorCode.CAPTCHA_BLANK, field: 'captcha' }],
      },
    };
  }

  verify(action = '') {
    if (!window.grecaptcha) {
      return Promise.reject(this.error);
    }

    return new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        try {
          window.grecaptcha.execute(this.key, { action })
            .then((token) => resolve({ token, isCaptchaV3: true }), () => reject(this.error));
        } catch (e) {
          reject(this.error);
        }
      });
    });
  }
}
